import { Stripe } from 'stripe';
import * as payment from '@webapp/sdk/payment';
import * as subscriptions from '@webapp/sdk/subscriptions';
import { NewSubscription } from '@services/subscription/types/new-subscription';
import { buildNewSubscription } from '@webapp/store/subscription/selectors';
import { CreateNewStripeSubscriptionReq } from '@webapp/types/stripe/create-new-stripe-subscription-req';
import { Subscription } from '@services/subscription/types/subscription';

export const createTrialSubscription = async (
  request: CreateNewStripeSubscriptionReq
): Promise<{
  type: 'setup' | 'payment';
  clientSecret: string;
  subscription: Subscription;
}> => {
  const {
    clientId,
    subscriptionType,
    order,
    externalPriceId,
    customer,
    coupon,
    trialDays,
  } = request;

  const newSubscription: NewSubscription = buildNewSubscription(
    clientId,
    subscriptionType,
    order
  );
  const subscription = await subscriptions.create(clientId, newSubscription);

  const stripeSubscription = await payment.createRecurringPayment(
    clientId,
    subscription.id,
    externalPriceId,
    customer,
    coupon?.externalId,
    trialDays
  );
  if (stripeSubscription.pending_setup_intent !== null) {
    return {
      subscription,
      type: 'setup',
      clientSecret: (
        stripeSubscription.pending_setup_intent as Stripe.SetupIntent
      ).client_secret as string,
    };
  } else {
    const intent = (stripeSubscription.latest_invoice as Stripe.Invoice)
      .payment_intent as Stripe.PaymentIntent;
    return {
      subscription,
      type: 'payment',
      clientSecret: intent.client_secret as string,
    };
  }
};
